import { GaugeDetails } from './GaugeDetails';

export default GaugeDetails;
